module.exports = __webpack_public_path__ + "static/img/Weight.77221af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/specialities/Weight.jpg
// module id = clM2
// module chunks = 7